"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconArrowsAltV = function IconArrowsAltV(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
  }));
};

IconArrowsAltV.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 512"
};

var IconTimes = function IconTimes(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  }));
};

IconTimes.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
};

var SelectListItem = function SelectListItem(_ref) {
  var children = _ref.children,
      onRemove = _ref.onRemove,
      isDragging = _ref.isDragging,
      dragHandleProps = _ref.dragHandleProps,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "onRemove", "isDragging", "dragHandleProps", "disabled"]);

  var _useState = (0, _react.useState)(false),
      isHoverOverAnchor = _useState[0],
      setIsHoverOverAnchor = _useState[1];

  var background = 'neutral.0';

  if (isDragging && !disabled) {
    background = 'neutral.2';
  } else if (isHoverOverAnchor && !disabled) {
    background = 'neutral.1';
  }

  return (0, _themeUi.jsx)(_themeUi.Flex, props, (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, dragHandleProps, {
    sx: {
      alignItems: 'center'
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHoverOverAnchor(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHoverOverAnchor(false);
    }
  }), (0, _themeUi.jsx)(_Icon["default"], {
    icon: IconArrowsAltV,
    sx: {
      color: 'textMediumEmphasis',
      flexShrink: 0
    }
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      bg: background,
      justifyContent: 'center',
      alignItems: 'center',
      pl: 3,
      pr: 1,
      minHeight: 3,
      py: 1,
      borderRadius: function borderRadius(theme) {
        return theme.radii.large + "px 0 0 " + theme.radii.large + "px";
      },
      display: 'inline-flex'
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    sx: {},
    variant: "caption"
  }, children))), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      bg: background,
      alignItems: 'center',
      flexShrink: 0,
      borderRadius: function borderRadius(theme) {
        return "0 " + theme.radii.large + "px " + theme.radii.large + "px 0";
      }
    }
  }, (0, _themeUi.jsx)(_ButtonIcon["default"], {
    icon: IconTimes,
    disabled: disabled,
    ariaLabel: "Remove",
    sx: {
      color: 'textMediumEmphasis',
      borderRadius: 'large',
      width: 3,
      height: 3,
      ':hover': {
        color: 'textWhite',
        bg: 'alerts.error'
      }
    },
    onClick: onRemove
  })));
};

SelectListItem.propTypes = {
  children: _propTypes["default"].string,
  onRemove: _propTypes["default"].func,
  isDragging: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  dragHandleProps: _propTypes["default"].shape({})
};
var _default = SelectListItem;
exports["default"] = _default;